/* @flow */
const prefix = str => `station/search/${str}`;

export const SET_VIEW_PANEL = prefix('SET_VIEW_PANEL');

export const TRIGGER_SEARCH = prefix('TRIGGER_SEARCH');
export const EXECUTE_SEARCH = prefix('EXECUTE_SEARCH');

export const SET_SEARCH_TERM = prefix('SET_SEARCH_TERM');
export const SET_SEARCH_OPTIONS = prefix('SET_SEARCH_OPTIONS');

export const SET_ENCLAVE_FILTER = prefix('SET_ENCLAVE_FILTER');
export const REMOVE_ENCLAVE_FILTER = prefix('REMOVE_ENCLAVE_FILTER');

export const SEARCH_IOCS = prefix('SEARCH_IOCS');
export const SEARCH_REPORTS = prefix('SEARCH_REPORTS');

export const FETCH_IOCS = prefix('FETCH_IOCS');
export const FETCH_IOCS_SUCCESS = prefix('FETCH_IOCS_SUCCESS');
export const FETCH_IOCS_FAILURE = prefix('FETCH_IOCS_FAILURE');

export const FETCH_REPORTS = prefix('FETCH_REPORTS');
export const FETCH_REPORTS_SUCCESS = prefix('FETCH_REPORTS_SUCCESS');
export const FETCH_REPORTS_FAILURE = prefix('FETCH_REPORTS_FAILURE');

export const UPDATE_REPORT_PAGE_FILTERS = prefix('UPDATE_REPORT_PAGE_FILTERS');
export const CLEAR_REPORT_SEARCH_FILTERS = prefix('CLEAR_REPORT_SEARCH_FILTERS');

export const EXECUTE_REPORTS_SEARCH = prefix('EXECUTE_REPORTS_SEARCH');
export const SEARCH_REPORTS_SUCCESS = prefix('SEARCH_REPORTS_SUCCESS');
export const SEARCH_REPORTS_FAILURE = prefix('SEARCH_REPORTS_FAILURE');

export const UPDATE_ENTITY_PAGE_FILTERS = prefix('UPDATE_ENTITY_PAGE_FILTERS');
export const CLEAR_ENTITY_SEARCH_FILTERS = prefix('CLEAR_ENTITY_SEARCH_FILTERS');

export const EXECUTE_ENTITIES_SEARCH = prefix('EXECUTE_ENTITIES_SEARCH');
export const SEARCH_ENTITIES_SUCCESS = prefix('SEARCH_ENTITIES_SUCCESS');
export const SEARCH_ENTITIES_FAILURE = prefix('SEARCH_ENTITIES_FAILURE');

export const UPDATE_SEARCH_PAGE_FILTERS = prefix('UPDATE_SEARCH_PAGE_FILTERS');
export const CLEAR_SEARCH_PAGE_FILTERS = prefix('CLEAR_SEARCH_PAGE_FILTERS');



// WEBPACK FOOTER //
// ./src/app/modules/search/action-types.js